module.exports = __webpack_public_path__ + "static/media/playlist_complete.ff1654b9.svg";